import { render, staticRenderFns } from "./SuggestionHistory.vue?vue&type=template&id=66d2feb0&"
import script from "./SuggestionHistory.vue?vue&type=script&lang=ts&"
export * from "./SuggestionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionHistory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports